import { Address } from "types";

export const formatAddress = (address: Address | undefined) =>
  address && address.street_address && address.zip_code && address.city
    ? `${address.street_address}, ${formatAddressCity(address)}`
    : "";

export const formatAddressCity = (address: Address) => `${address.zip_code}, ${address.city}`;
